var _rect, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClamorBlackWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 305,
    height: 305,
    viewBox: "0 0 305 305",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 26.0347,
    y: 26.0344,
    width: 252.931,
    height: 252.931,
    rx: 46,
    fill: "#D9D9D9",
    stroke: "white",
    strokeWidth: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_279_5098)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M163.95 218.957C163.95 218.957 237.194 223.912 217.976 200.787C198.758 177.661 182.765 191.013 182.765 191.013L163.95 218.957Z",
    fill: "#E51E4D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.124 228.75C161.307 228.75 138.622 225.217 134.752 224.673C106.196 219.916 88.9815 208.363 83.3769 190.422C69.7658 146.384 135.019 80.5999 137.821 77.8815C140.09 75.7068 143.559 75.7068 145.695 78.0174C147.83 80.328 147.83 83.8619 145.561 86.0366C128.08 103.57 84.4444 156.034 94.0523 187.024C98.189 200.48 112.601 209.314 136.487 213.392C141.157 214.071 148.363 215.159 156.637 215.838C159.039 208.499 165.311 195.043 179.989 186.344C196.136 176.694 206.945 180.364 212.015 183.49C219.221 187.975 223.758 196.538 223.358 205.509C223.091 213.664 218.821 220.595 212.149 223.993C205.343 227.527 194.134 228.75 182.124 228.75ZM168.246 216.79C183.726 217.741 199.872 217.605 207.211 213.935C211.482 211.761 212.149 207.14 212.282 205.237C212.416 200.344 210.147 195.722 206.277 193.412C201.207 190.286 194.001 191.373 185.727 196.266C175.719 202.111 170.648 210.945 168.246 216.79Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_279_5098"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 141.983,
    height: 152.5,
    fill: "white",
    transform: "translate(81.5088 76.25)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClamorBlackWhite);
export default __webpack_public_path__ + "static/media/clamor-black-white.ea2943376104930a52fe99eef1f865f3.svg";
export { ForwardRef as ReactComponent };